<template>
  <NuxtLayout name="default-no-footer">
    <favourites-index :key="useRoute().path" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { nextTick } from 'vue'
import { useAppMenuStore } from '~/stores/useAppMenuStore' // Assuming this is where your store is
import SCHEMA_ORGANIZATION from '../../json/schemaOrganization.json'

const appMenuStore = useAppMenuStore(usePinia())
const title = useI18n().t('Favourites')

definePageMeta({
  layout: false,
})

useHead({
  title: () => `${title} | Pitchup.com`,
  bodyAttrs: {
    class: 'active-tab-favourites',
  },
  meta: [
    {
      hid: 'robots',
      name: 'robots',
      content: 'noindex',
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      body: true,
      innerHTML: JSON.stringify(SCHEMA_ORGANIZATION),
      hid: 'schema-organization',
    },
  ],
})

async function appMenuMounted() {
  appMenuStore.hideMenu()
  await nextTick()
}

onMounted(async () => {
  await appMenuMounted()
})
</script>
